import { Badge } from '@/components/ui/badge';
import { cn } from '@/utils/cn';

export const TradeSideBadge = ({ side }: { side?: string }) => {
    if (!side) {
        return null;
    }

    const isLong = side.toUpperCase() === 'LONG' || side.toUpperCase() === 'BUY';
    const colorClasses = isLong
        ? 'bg-green-100 text-green-800 hover:bg-green-200 border-green-200'
        : 'bg-red-100 text-red-800 hover:bg-red-200 border-red-200';

    return <Badge className={cn('border-transparent', colorClasses)}>{side.toUpperCase()}</Badge>;
};
